import {
	type CommandConstructor,
	type CommandProperties,
	type SerializableValue,
} from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

/**
 * Data payload for removing an AVP dashboard row.
 */
export type AvpDashboardRemoveRowData = {
	/**
	 * The ARI of the AVP dashboard to remove the row from.
	 */
	dashboardAri: string;
	/**
	 * The identifier of the row to remove.
	 */
	rowId: string;
	/**
	 * The canvas layout configuration after the row has been removed.
	 */
	canvasLayout: SerializableValue;
};

/**
 * Properties for the AVP dashboard row removal command.
 *
 * @extends CommandProperties
 */
export interface AvpDashboardRemoveRowCommandProperties extends CommandProperties {
	/**
	 * The unique key identifier for the row removal request.
	 */
	key: string;
	/**
	 * The data payload containing the row identifier.
	 */
	data: AvpDashboardRemoveRowData;
}

/**
 * A command sent by a bridge API client to remove a row from an AVP dashboard.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to remove an AVP dashboard row with the specified identifier.
 */
export const AvpDashboardRemoveRowCommand: CommandConstructor<
	AvpDashboardRemoveRowCommandProperties,
	SerializableValue
> = createCommand<AvpDashboardRemoveRowCommandProperties>('avp_dashboard_remove_row');
